import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tab, Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import { comnUtils } from "@/comn/utils";
import { useForm, useFetch, useModal, useAuth, useStore, useResource, useGrid, useTab } from "@/comn/hooks";
import {
    URLS,
    APIS,
    SF_APRVAPP_DTL,
    SF_APP_RGST_VRFN_RSLT,
    SG_APP_DTL_INSC_ATCM,
} from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";
import { APP_AMD_DTL_GEN } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_GEN";
import { APP_AMD_DTL_TRPT } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_TRPT";
import { APP_AMD_DTL_INVC } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_INVC";
import { APP_AMD_DTL_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_ITM";
import { APP_AMD_DTL_ATCM } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_ATCM";
import { APP_DTL_GEN } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_GEN";
import { APP_DTL_TRPT } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_TRPT";
import { APP_DTL_INVC } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_INVC";
import { APP_DTL_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ITM";
import { APP_DTL_ATCM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ATCM";
import { APP_DTL_PAY_INFO } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_PAY_INFO";
import { APP_DTL_MSG } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_MSG";
import { APP_DTL_DCLR } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_DCLR";

/**
 * Amend/Cancel LPCO Application Verification Detail for Approval
 * !== 결재를 위한 정정/취소 LPCO 신청서 심사 상세 ==!
 */
export const OSCI0201030Q = (props: any) => {
    // 2026-05-07 KNH: !== 컴포넌트 리소스 정의 ==!
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0131" }, // 신청서 상태 코드
            { area: "comnCd", comnCd: "OSC0142" }, // 신청서 상태 변경 코드
        ],
    });

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    // const { pgeUid, menuId, back } = usePage({
    // 2026-05-07 KNH: !== 결재를 위한 화면이므로 권한 체크 필요 없음 ==!
    // auth: ["auth_osci0006", "auth_osci0015"],
    // });
    const pgeUid = "OSCI0201030Q";

    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore } = useStore({ pgeUid });
    const auth = useAuth();
    const { appId } = useParams();
    const location = useLocation();
    const [param, setParam] = useState<any>({ ...(location.state ?? {}) });
    let tabSchemaList: any[] = [];
    const [gnrl, setGnrlVisible] = useState(false);
    const [trpt, setTrptVisible] = useState(false);
    const [invc, setInvcVisible] = useState(false);
    const [itm, setItmVisible] = useState(false);
    const [atcm, setAtcmVisible] = useState(false);
    const [payInfo, setPayInfoVisible] = useState(false);
    const [msg, setMsgVisible] = useState(false);
    const [dclr, setDclrVisible] = useState(false);
    const [amdRsnVisible, setAmdRsnVisible] = useState(false);
    const [cnclRsnVisible, setCnclRsnVisible] = useState(false);
    const [comnCdList, setComnCdList] = useState<any[]>([]);
    const [bfAppParam, setBfAppParam] = useState<any>({});
    // Assignment officer type of the row being shown (VE/IP) !== 표시 중인 배정행의 담당자 유형 ==!
    const [asnmtOfcrTpCd, setAsnmtOfcrTpCd] = useState("");
    // Inspection attachment list (approval review, read-only) !== 검사 첨부파일 목록 (결재 열람 전용) ==!
    const [atcmList, setAtcmList] = useState(comnUtils.getGridData([]));

    /*
     * Application Detail Form
     * !== 폼 정의 ==!
     */
    const form = {
        // 심사 결과(결재 조회용)
        appRgstVrfnRslt: useForm({
            defaultSchema: SF_APP_RGST_VRFN_RSLT,
            defaultValues: {},
        }),
        // 정정 후(현재 신청서)
        mdfyAppDtl: useForm({
            defaultSchema: SF_APRVAPP_DTL,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
        // 정정 전(비교용)
        bfAmdAppDtl: useForm({
            defaultSchema: SF_APRVAPP_DTL,
            defaultValues: {},
        }),
    };

    /*
     * Pre-Application Tab
     * !== 탭 정의 ==!
     */
    const tab = {
        tabSchema: useTab({
            defaultSchema: {
                id: "tab",
                schema: tabSchemaList,
            },
        }),
    };

    const render = {
        tabView: () => {
            const tabPanelList: any[] = [];
            comnCdList?.forEach((item: any) => {
                if ("GEN" === item.value) {
                    tabPanelList.push(
                        <Tab.Panel key={item.value}>
                            {/* Cancellation has no before/after — show plain detail
                                !== 취소는 정정 전/후가 없어 일반 상세로 표시 ==! */}
                            {gnrl &&
                                (param.amdTpCd == "C" ? (
                                    <APP_DTL_GEN state={param} />
                                ) : (
                                    <APP_AMD_DTL_GEN state={param} form={form.bfAmdAppDtl} bfParam={bfAppParam} />
                                ))}
                        </Tab.Panel>,
                    );
                } else if ("TRN" === item.value) {
                    tabPanelList.push(
                        <Tab.Panel key={item.value}>
                            {trpt &&
                                (param.amdTpCd == "C" ? (
                                    <APP_DTL_TRPT state={param} />
                                ) : (
                                    <APP_AMD_DTL_TRPT state={param} form={form.bfAmdAppDtl} bfParam={bfAppParam} />
                                ))}
                        </Tab.Panel>,
                    );
                } else if ("INV" === item.value) {
                    tabPanelList.push(
                        <Tab.Panel key={item.value}>
                            {invc &&
                                (param.amdTpCd == "C" ? (
                                    <APP_DTL_INVC state={param} />
                                ) : (
                                    <APP_AMD_DTL_INVC state={param} form={form.bfAmdAppDtl} bfParam={bfAppParam} />
                                ))}
                        </Tab.Panel>,
                    );
                } else if ("ITM" === item.value) {
                    tabPanelList.push(
                        <Tab.Panel key={item.value}>
                            {itm &&
                                (param.amdTpCd == "C" ? (
                                    <APP_DTL_ITM state={param} />
                                ) : (
                                    <APP_AMD_DTL_ITM state={param} form={form.bfAmdAppDtl} bfParam={bfAppParam} />
                                ))}
                        </Tab.Panel>,
                    );
                } else if ("ATC" === item.value) {
                    tabPanelList.push(
                        <Tab.Panel key={item.value}>
                            {atcm &&
                                (param.amdTpCd == "C" ? (
                                    <APP_DTL_ATCM state={param} />
                                ) : (
                                    <APP_AMD_DTL_ATCM state={param} form={form.bfAmdAppDtl} />
                                ))}
                        </Tab.Panel>,
                    );
                } else if ("PAY" === item.value) {
                    tabPanelList.push(
                        <Tab.Panel key={item.value}>
                            {payInfo && <APP_DTL_PAY_INFO state={param} form={form.bfAmdAppDtl} />}
                        </Tab.Panel>,
                    );
                } else if ("MSG" === item.value) {
                    tabPanelList.push(
                        <Tab.Panel key={item.value}>
                            {msg && <APP_DTL_MSG state={param} form={form.bfAmdAppDtl} />}
                        </Tab.Panel>,
                    );
                } else if ("DCL" === item.value) {
                    tabPanelList.push(
                        <Tab.Panel key={item.value}>
                            {dclr && <APP_DTL_DCLR state={param} form={form.bfAmdAppDtl} />}
                        </Tab.Panel>,
                    );
                }
            });
            return tabPanelList;
        },
    };

    /*
     * Inspection Attachment Grid
     * !== 검사 첨부파일 그리드 ==!
     */
    const grid = {
        appDtlInscAtcm: useGrid({
            defaultSchema: SG_APP_DTL_INSC_ATCM,
        }),
    };

    /*
     * Master Applidation Details Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Application Information !== 신청서 정보 조회 ==!.

        // 현재(정정 후) 신청서 조회
        getAppInfo: useFetch({
            api: (id) => APIS.getAppInfo({ appId: id, orgCd: auth.get("orgCd") }),
            onSuccess: async (data) => {
                const content = data?.appInfo?.content ?? {};
                form.mdfyAppDtl.setValues({ ...content });
                setParam({ ...content });
                if (content?.amdTpCd === "A") {
                    setAmdRsnVisible(true);
                    setCnclRsnVisible(false);
                } else if (content?.amdTpCd === "C") {
                    setAmdRsnVisible(false);
                    setCnclRsnVisible(true);
                } else {
                    setAmdRsnVisible(false);
                    setCnclRsnVisible(false);
                }
                // 정정 전 원본 조회
                // Load before-amendment info first so tab children get bfParam on mount
                // !== 자식 탭이 mount 시 bfParam을 받도록 정정 전 정보를 먼저 조회 ==!
                await fetch.getBeforeAppInfo.fetch({ ...content });

                handler.getTabSchemaList(content);
            },
            onError: () => {},
        }),
        // 정정 전 신청서 조회
        getBeforeAppInfo: useFetch({
            api: (data) => APIS.getBeforeAppInfo({ ...data }),
            onSuccess: (data) => {
                const content = data?.appInfo?.content ?? {};
                form.bfAmdAppDtl.setValues({ ...content });
                // Trigger tab re-render with before app keys !== 정정 전 appId 전달을 위해 state 갱신 ==!
                setBfAppParam({ ...content });
            },
            onError: () => {},
        }),
        // 결재/심사 결과 조회
        getAppAprvInfo: useFetch({
            api: (id) => APIS.getAppAprvInfo({ reffId: id }),
            onSuccess: (data) => {
                const aprvInfo = data?.appAprvInfo?.content ?? {};
                form.appRgstVrfnRslt.setValues({ ...aprvInfo });
                setAsnmtOfcrTpCd(aprvInfo.asnmtOfcrTpCd);
                // Inspection step with inspected result carries attachments !== 검사 단계이고 결과가 검사면 첨부 조회 ==!
                if (aprvInfo.asnmtOfcrTpCd === "IP" && aprvInfo.prcssStatCd === "IP") {
                    fetch.getInscAtcmList.fetch(0);
                }
            },
            onError: (error) => {
                const errmsg =
                    error?.response?.data?.errorCode === -1 ? "msg.osc.00015" : error?.response?.data?.errorMessage;
                modal.openModal({ content: errmsg || "msg.osc.00015" });
            },
        }),
        // Get Inspection Attachment List !== 검사 첨부파일 목록 조회 ==!
        getInscAtcmList: useFetch({
            api: (page = grid.appDtlInscAtcm.page) => {
                return APIS.getInscAtcmList({ ...param }, page, grid.appDtlInscAtcm.size);
            },
            key: [grid.appDtlInscAtcm.page, grid.appDtlInscAtcm.size],
            onSuccess: (data) => {
                if (data.atcmList.content!) {
                    setAtcmList(comnUtils.getGridData(data.atcmList.content));
                }
            },
            onError: () => {},
            showToast: false,
        }),
    };

    /*
     * Application Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            await fetch.getAppInfo.fetch(appId);
            await fetch.getAppAprvInfo.fetch(appId);
        },
        getTabSchemaList: async (data: any) => {
            const reqParam = { orgCd: data.orgCd, appCdNo: data.appCdNo, appTpCd: data.appTpCd };
            const cpntList = await lpcoUtils.getCpntList(reqParam);
            tabSchemaList = [];
            cpntList?.forEach((item: any) => {
                if (item.value !== "CON") {
                    tabSchemaList.push({ label: item.label });
                }
            });
            tab.tabSchema.setSchema(tabSchemaList);
            setComnCdList(cpntList || []);
        },
        clearTabVisible: () => {
            setGnrlVisible(false);
            setTrptVisible(false);
            setInvcVisible(false);
            setItmVisible(false);
            setAtcmVisible(false);
            setPayInfoVisible(false);
            setMsgVisible(false);
            setDclrVisible(false);
        },
        changeTab: (index: number) => {
            handler.clearTabVisible();
            const tabInfo: any = comnCdList?.[index];
            switch (tabInfo?.value) {
                case "GEN":
                    setGnrlVisible(true);
                    break;
                case "TRN":
                    setTrptVisible(true);
                    break;
                case "INV":
                    setInvcVisible(true);
                    break;
                case "ITM":
                    setItmVisible(true);
                    break;
                case "ATC":
                    setAtcmVisible(true);
                    break;
                case "PAY":
                    setPayInfoVisible(true);
                    break;
                case "MSG":
                    setMsgVisible(true);
                    break;
                case "DCL":
                    setDclrVisible(true);
                    break;
                default:
                    break;
            }
            tab.tabSchema.setActive(index);
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    useEffect(() => {
        if (comnCdList && comnCdList.length > 0) {
            handler.changeTab(0);
        }
    }, [comnCdList]);

    useEffect(() => {
        setParam({ ...(location.state ?? {}) });
    }, [location.state]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.mdfyAppDtl.schema.appNo} />
                            <Group.Control {...form.mdfyAppDtl.schema.ucrNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.mdfyAppDtl.schema.appNm} />
                            <Group.Control {...form.mdfyAppDtl.schema.appTpNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.mdfyAppDtl.schema.sbmtDtm} />
                            <Group.Control {...form.mdfyAppDtl.schema.aprvDtm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.mdfyAppDtl.schema.appStatNm} />
                            <Group.Control {...form.mdfyAppDtl.schema.appXpirDt} />
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button role="list" onClick={() => navigate(URLS.osci0201017q)} />
                        </Layout.Left>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        {amdRsnVisible && (
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"L_AMD_RSN_1"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>
                        )}
                        {cnclRsnVisible && (
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"L_CNCL_RSN_1"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>
                        )}
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.mdfyAppDtl.schema.amdRsn} controlSize={12} />
                            </Group.Row>
                        </Group.Section>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title
                                title={asnmtOfcrTpCd === "IP" ? "T_INSC_RSLT" : "T_VRFN_RSLT"}
                                titleSize={1}
                            ></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.appRgstVrfnRslt.schema.prcssStatCd}
                                label={asnmtOfcrTpCd === "IP" ? "L_INSC_RSLT" : "L_VRFN_RSLT"}
                                controlSize={10}
                                edit={false}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.appRgstVrfnRslt.schema.prcssRsnCn}
                                label={asnmtOfcrTpCd === "IP" ? "L_INSC_RMRK" : "L_VRFN_RMRK"}
                                controlSize={10}
                                edit={false}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.appRgstVrfnRslt.schema.rmrk} controlSize={10} edit={false} />
                        </Group.Row>
                    </Group.Section>
                    {asnmtOfcrTpCd === "IP" &&
                        form.appRgstVrfnRslt.getValue("prcssStatCd") === "IP" &&
                        atcmList.content.length > 0 && (
                            <>
                                <Group.Title title={"T_ATCM"} titleSize={2}></Group.Title>
                                <Grid {...grid.appDtlInscAtcm.grid} data={atcmList} />
                            </>
                        )}
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Tab
                        {...tab.tabSchema.tab}
                        onChange={(index) => {
                            handler.changeTab(index as number);
                        }}
                    >
                        {render.tabView()}
                    </Tab>
                </Group.Body>
            </Group>
        </Page>
    );
};
